// Vendor imports
const Immutable = require('immutable')
// Client V2 common imports
const {
  defaultReviver,
  keyedReviver
} = require('client-v2/common/state/record-reviver')

class EnvironmentRecord extends Immutable.Record({
  articlePlaceholder: String(),
  baseUrl: String(),
  bookmarkletHref: String(),
  browser: Immutable.Map(),
  buildNumber: String(),
  csrfToken: String(),
  deeplinkUrls: Immutable.Map(),
  iconsUrl: String(),
  nativeEmbedded: Boolean(),
  openInAppDismissed: Boolean(),
  userPlaceholder: String()
}) {
  // No methods
}

EnvironmentRecord.reviver = keyedReviver(EnvironmentRecord, {
  browser: defaultReviver,
  deeplinkUrls: defaultReviver
})

module.exports = EnvironmentRecord
